import { useState } from 'react'
import { Image as ImageIcon, Trash2, Upload } from 'lucide-react'
import { verklein } from '../lib/afbeelding'
import { foutTekst, vraag } from '../lib/api'

/*
 * Een foto kiezen (op een telefoon of tablet ook met de camera), verkleind
 * in de browser en opgeslagen met `actie` (beloning-, tier- of
 * promotie-afbeelding). `bijgewerkt` krijgt het antwoord van de server.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function AfbeeldingKiezen({ actie, id, url, bijgewerkt }: { actie: string; id: string; url: string | null; bijgewerkt: (r: any) => void }) {
  const [bezig, zetBezig] = useState(false)
  const [fout, zetFout] = useState<string | null>(null)
  const stuur = async (data: string | null) => {
    zetBezig(true); zetFout(null)
    try { bijgewerkt(await vraag(actie, { id, data })) } catch (e) { zetFout(foutTekst(e)) } finally { zetBezig(false) }
  }
  return (
    <div className="rij" style={{ alignItems: 'center', gap: 14 }}>
      {url ? <img className="beloning-foto groot" src={url} alt="" /> : <span className="beloning-foto groot leeg"><ImageIcon size={28} /></span>}
      <div className="lijst" style={{ gap: 8 }}>
        <label className="knop klein-knop" style={{ cursor: bezig ? 'wait' : 'pointer' }}>
          <Upload size={16} />{bezig ? 'Bezig…' : url ? 'Andere foto' : 'Foto kiezen'}
          <input type="file" accept="image/*" hidden disabled={bezig} onChange={async (e) => {
            const f = e.target.files?.[0]
            e.target.value = ''
            if (!f) return
            try { await stuur(await verklein(f)) } catch (x) { zetFout(foutTekst(x)) }
          }} />
        </label>
        {url && !bezig && <button type="button" className="knop klein-knop stil-knop" onClick={() => stuur(null)}><Trash2 size={16} />Weghalen</button>}
      </div>
      {fout && <div className="melding fout" style={{ flexBasis: '100%' }}>{fout}</div>}
    </div>
  )
}
